import { Directive, HostListener, Input } from '@angular/core';
import { Gtm } from '@df/module-gtm/gtm.namespace';
import { GtmService } from '@df/module-gtm/gtm.service';

/**
 * ## Usage
 *
 * ```html
 * <a ... [gtmTrackClick]="{category: C, action: A, value: V, label: E}">...</a>
 * ```
 */
@Directive()
export abstract class GtmTrackClickDirectiveDef {
    @Input({
        required: true
    })
    gtmTrackClick!: Gtm.ITrackClickData;

    @Input()
    gtmTrackClickOff? : boolean;

    constructor(private gtmService: GtmService) {}

    /**
     * Click event listener
     */
    @HostListener('click')
    onClick() {
        if (!this.gtmTrackClickOff) {
            const data = this.gtmTrackClick;

            this.gtmService.trackInteractionEvent(data.category, data.action, data.label, data.value);
        }
    }
}
